import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { getProtocols, getUserSettings } from '@/api/apiService'
import { QueryKeys } from '../models/enum'
import { ResponseObject, UseGetReadModel, UserSettingsDto } from '../models/types'

function protocolsService(): UseQueryResult<string[], AxiosError<ResponseObject>> {
    return useQuery<string[], AxiosError<ResponseObject>>({
        queryKey: [QueryKeys.Protocols],
        queryFn: getProtocols,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    })
}

export function useGetProtocols(): UseGetReadModel<string[]> {
    const { isLoading, error, data = [] } = protocolsService()
    return {
        isLoading,
        data: data,
        error,
        errorMessage: error?.message,
    }
}
